<template>
  <div class="container">
    <div class="body-container">
      <h2>{{ page.info.CwareName }}</h2>
      <!-- <video-player
      class="video-player vjs-custom-skin video-custom"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
    >
    </video-player> -->
      <LivePlayer
        id="myplayer"
        :videoUrl="LivePlayerOptions.videoUrl"
        :poster="LivePlayerOptions.poster"
        :alt="LivePlayerOptions.alt"
        :muted="LivePlayerOptions.muted"
        :aspect="LivePlayerOptions.aspect"
        :live="LivePlayerOptions.live"
        :controls="LivePlayerOptions.controls"
        @play="onPlay"
        @pause="onPause"
        :hide-snapshot-button="LivePlayerOptions.hideSnapshotButton"
        :loading="LivePlayerOptions.loading"
        ref="player"
      />
      <p class="p" v-if="IsTrainStudy">
        <span class="sp">
          观看时长：{{ TotalViewStr }}，状态：{{
            ViewState == 0 ? "学习中" : "学习完成"
          }}
        </span>
        <van-button
          plain
          type="success"
          class="save-btn"
          @click="handSave"
          style="float: right"
          >保存学习进度</van-button
        >
      </p>
    </div>
    <div class="list-container">
      <h2 style="text-align: left">推荐视频</h2>
      <div v-for="item in page.rows">
        <div class="gallery-list">
          <img
            class="gallery-img"
            mode="widthFix"
            :src="item.PreImageUrl"
            alt=""
          />
          <div class="gallery-box gallery-left" style="position: relative">
            <div class="gallery-name">
              {{ item.CwareName }}
            </div>
            <div class="gallery-detail">视频时长：{{ item.FileTimeStr }}</div>
            <div class="gallery-detail"></div>
            <van-button type="success" plain class="right-bottom" @click="toVideo(item)"
              >观看视频</van-button
            >
            <!-- <vant-button plain type="primary" data-id="{{item.Rid}}" class="right-bottom" bind:click="toVideoDetail">观看视频</van-button> -->
          </div>
        </div>
        <van-divider />
      </div>
    </div>
  </div>
</template>

<script setup>
import "../assets/css/style.css";
import { onMounted, reactive, ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { showDialog } from 'vant';
import LivePlayer from "@liveqing/liveplayer-v3";

var timer = null;
var TotalViewStr = ref("");
var ViewState = ref(0);
var IsTrainStudy = ref(false);
var ViewTimes = ref(0);
var TotalViewTimes = ref(0);
var classId = null;
var trainId = null;

const { proxy } = getCurrentInstance();
const $router = useRouter();
onMounted(() => {
  var id = $router.currentRoute.value.query.id; //$router.query.id;
  classId = $router.currentRoute.value.query.classid;
  trainId = $router.currentRoute.value.query.trainid;
  let tokenstr = $router.currentRoute.value.query.token;
  if(tokenstr){
    sessionStorage.setItem("token", decodeURIComponent(tokenstr));
  }
  if (classId>'0') {
    IsTrainStudy.value = true;
  }
  proxy.$get("Access/GetStudyModel", { id: id }).then((res) => {
    if (res.result == 1) {
      res.recommdList.forEach((v, i) => {
        v.FileTimeStr = GetTimeStr(v.FileTimeLenth);
      });
      page.rows = res.recommdList;
      page.total = res.recommdList.length;
      page.info = res.data;
      LivePlayerOptions.poster = res.data.PreImageUrl;
      LivePlayerOptions.videoUrl = res.data.TxQhdurl;
      ViewState.value = res.playTimeInfo ? res.playTimeInfo.ViewState : 0;
      TotalViewTimes.value = res.playTimeInfo ? res.playTimeInfo.ViewTimes : 0;
      TotalViewStr.value = GetTimeStr(TotalViewTimes.value);
      if(IsTrainStudy.value){
        setTimeout(() => {
        SetCurrentTime(TotalViewTimes.value);
      }, 1000);
      }
    }
  });
});

const handSave=()=>{
  sendSave(function(){
    showDialog({title:"提示",message:"保存成功"});
  },function(){
    showDialog({title:"提示",message:"保存失败"});
  });
}
let isSave = false
const sendSave = (successFun,errorFun) => {
  var obj = {
    Rid: page.info.Rid,
    FileTimeLenth: page.info.FileTimeLenth,
    ViewTimes: ViewTimes.value,
    ClassId: classId,
    TrainId: trainId,
  };
  if(isSave){
    return
  }
  isSave = true
  proxy.$post("/Access/SaveViewRec", obj).then((res) => {
    isSave = false
    if (res.result == 1) {
      ViewState.value = res.data.ViewState;
      if(typeof(successFun)=='function'){
        successFun();
      }
    }
    else{
      if(typeof(errorFun)=='function'){
        errorFun();
      }
    }
  });
};

const LivePlayerOptions = reactive({
  videoUrl: "", //视频地址
  poster: "", //封面图片
  autoplay: true, //自动播放
  controls: true, //显示播放器控制栏
  loop: false, //是否循环播放
  live: false, // 是否直播, 标识要不要显示进度条
  alt: "无信号", //视频流地址没有指定情况下, 视频所在区域显示的文字, 相当于 html img 标签的 alt 属性, String default '无信号'
  muted: false, //是否静音
  aspect: "16:9", //视频显示区域的宽高比
  hideStretchButton: false,
  hideSnapshotButton: true,
  loading: true,
  // stretch:true,//是否拉伸
  // language:"",//语言(zh-CN/en),
});
const page = reactive({
  total: 0,
  rows: [],
  info: {},
});

const GetTimeStr = (second) => {
  if (!second || second == 0) {
    return "";
  }
  let str = "";
  let minute = parseInt(second / 60);
  if (minute > 0) {
    str += minute + "分钟";
  }
  let sySecond = parseInt(second % 60);
  if (sySecond > 0) {
    str += sySecond + "秒";
  }
  return str;
};
const toVideo = (item)=>{
    $router.replace({path:'/play',query:{id:item.Rid}})
}
//播放
const onPlay = () => {
  if (IsTrainStudy.value && ViewState.value == 0) {
    if (timer == null) {
      timer = setInterval(() => {
        ViewTimes.value += 1;
        TotalViewTimes.value += 1;
        TotalViewStr.value = GetTimeStr(TotalViewTimes.value);
        //间隔n秒提交一次
        if (ViewTimes.value % 30 == 0) {
          //提交
          sendSave();
          //清零，否则可能导致时间叠加
          ViewTimes.value = 0;
        }
      }, 1000);
    }
  }
};
//暂停
const onPause = () => {
  clearInterval(timer);
  timer = null;
};
// const getCurrentTime = ()=>{
//   var player = proxy.$refs.player;
//   var a = player.getCurrentTime();
// }
const SetCurrentTime=(time)=>{
  var player  = proxy.$refs.player;
  player.setCurrentTime(time);
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  margin-top: 0;
}
.container {
  background: gainsboro;
}
.body-container {
  padding: 0 20px 20px 20px;
  background: #fff;
  margin-top: 20px;
}
.list-container {
  padding: 10px 20px 0 20px;
  background: #fff;
  margin-top: 10px;
}
.video-container {
  display: inline-block;
  width: 700px;
  height: 438px;
  text-align: center;
  line-height: 100px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  /* box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2); */
  margin-right: 4px;
}
/* .video-custom {
  width: 100vw;
  height: 75vw;
} */
.video-js {
  width: 375px;
  height: 240px;
  margin-top: 10px;
}
.right-bottom {
  width: 85px;
  height: 35px;
  font-size: 12px;
}
.save-btn {
  width: 110px;
  height: 35px;
  font-size: 12px;
  margin-top: 5px;
}
.p{
    height: 30px;
    text-align: left
}
.sp{
    font-size: 12px;
    margin-top: 15px;
    display: inline-block;
}
#myplayer{
    margin-top: 20px;
}
</style>